<template>
    <div class="schedule-page">
        <page-hero title="Πρόγραμμα" eyebrow="Match Center" compact />
        <div class="cl-page">
            <v-container fluid no-gutters class="my-0 py-0">
                <filters :cup="true" @getScheduleByLeague="getByFilters" @getByFilters="getByFilters" @getCupState="getCupState" @clear="clearData" />
                <schedule-match-center :matches="matches" />
            </v-container>
        </div>
    </div>
</template>

<script>
    import PageHero from '@/components/PageHero'
    import ScheduleMatchCenter from '@/components/ScheduleMatchCenter'
    import Filters from '@/components/GenericFilters'
    import matchService from '@/services/match'

    export default {
        components: { PageHero, ScheduleMatchCenter, Filters },
        data() {
            return {
                matches: [],
                // the matches of the latest choice only
                requestId: 0
            }
        },
        methods: {
            // another season: nothing on screen until its matches come
            clearData() {
                this.requestId++
                this.matches = []
            },
            getCupState(isCup, leagueId, seasonId) {
                const filters = isCup
                    ? { cup: '"isCup": true' }
                    : { phase: '"phase": "playoffs"', league: `"league": ${leagueId}`, season: `"season": ${seasonId}` }
                this.load(filters)
            },
            getByFilters(round = null, arenaId = null, isCup = null, leagueId = null, seasonId = null, phase = null) {
                const filters = {}
                if (round) {
                    filters.round = `"round": ${Number(round)}`
                }
                if (arenaId !== null) {
                    filters.arena = `"arena": ${arenaId}`
                }
                if (isCup) {
                    filters.cup = '"isCup": true'
                } else if (phase !== null) {
                    filters.phase = `"phase": "${phase}"`
                }
                if (leagueId !== null) {
                    filters.league = `"league": ${leagueId}`
                }
                if (seasonId !== null) {
                    filters.season = `"season": ${seasonId}`
                }
                this.load(filters)
            },
            load(filters) {
                const requestId = ++this.requestId
                matchService.getMatches(1, 300, filters).then(resp => {
                    if (requestId === this.requestId) this.matches = resp.data.content
                }).catch(() => {
                    if (requestId === this.requestId) this.matches = []
                })
            }
        }
    }
</script>
